import { formatearMontoGasto } from '../../utils/gastos'

const MAXIMO_VISIBLE = 6

function GastosPorCategoria({ categorias, totalMes }) {
  const principales = categorias.slice(0, MAXIMO_VISIBLE)
  const restantes = categorias.length - principales.length

  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
      <h3 className="text-lg font-bold text-slate-900">
        Gastos por categoría
      </h3>

      <p className="mt-1 text-sm text-slate-500">
        Distribución del mes actual.
      </p>

      {principales.length === 0 ? (
        <p className="mt-6 text-sm text-slate-500">
          No hay gastos registrados este mes.
        </p>
      ) : (
        <div className="mt-6 space-y-4">
          {principales.map((categoria) => {
            const porcentaje =
              totalMes > 0
                ? (categoria.total / totalMes) * 100
                : 0

            return (
              <div key={categoria.nombre}>
                <div className="flex items-center justify-between gap-3 text-sm">
                  <span className="font-semibold text-slate-800">
                    {categoria.nombre}
                  </span>

                  <span className="shrink-0 text-slate-500">
                    {formatearMontoGasto(categoria.total)} ·{' '}
                    {porcentaje.toLocaleString('es-CL', {
                      maximumFractionDigits: 1,
                    })}
                    %
                  </span>
                </div>

                <div className="mt-1.5 h-2 w-full overflow-hidden rounded-full bg-slate-100">
                  <div
                    className="h-full rounded-full bg-emerald-500"
                    style={{ width: `${porcentaje}%` }}
                  />
                </div>
              </div>
            )
          })}
        </div>
      )}

      {restantes > 0 && (
        <p className="mt-4 text-xs font-semibold text-slate-400">
          + {restantes}{' '}
          {restantes === 1
            ? 'categoría adicional'
            : 'categorías adicionales'}
        </p>
      )}
    </div>
  )
}

export default GastosPorCategoria
